export default __webpack_public_path__ + "static/media/Group_7474.7d2ee791.png";